import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frTranslations from './locales/fr.json';
import enTranslations from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations },
      en: { translation: enTranslations }
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    // Without this, the detector can return regional codes like "en-US" or
    // "fr-FR" (from navigator.language), which don't match the bare "en"/
    // "fr" resource keys below — every t() call then misses and falls back
    // to fallbackLng or the inline default, and the FR/EN toggle button
    // (which does `i18n.language === 'fr' ? 'en' : 'fr'`) can end up
    // needing two clicks instead of one.
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;